import { dataToExecData, ExecArgBase } from '../ExecArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecArgSwapExactOutput extends ExecArgBase {
    static fromJSON(params) {
        return new ExecArgSwapExactOutput(params);
    }
    toData() {
        const { params } = this;
        return {
            target_output_quantity: params.targetOutputQuantity,
            target_denom: params.targetDenom,
            ...(params.feeRecipient && {
                fee_recipient: params.feeRecipient,
            }),
        };
    }
    toExecData() {
        return dataToExecData('swap_exact_output', this.toData());
    }
}
